import { STRAPI_URL } from "./constants";

export function getStrapiMediaUrl(url: string | undefined): string {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${STRAPI_URL}${url.startsWith("/") ? url : `/${url}`}`;
}
